import { memo } from 'react';
import { useRecoilValue } from 'recoil';

import { trimmedAddress } from 'helpers';
import { authState } from 'store/state';

import Dropdown from 'components/UI/Dropdown';
import {
    LogoutIcon,
    CopyIcon,
} from 'components/Icons';
import copy from 'copy-to-clipboard';
import WalletButton from './WalletButton';

const WalletDropdown = ({
    t,
    onLogout,
}) => {
    const auth = useRecoilValue(authState);
    const address = trimmedAddress(auth.currentAddress);

    const Trigger = () => <WalletButton address={address} />;

    return (
        <Dropdown Trigger={Trigger}>
            <li onClick={() => copy(auth.currentAddress)}>
                <CopyIcon color="var(--brand)" />
                <span>Copy your address</span>
            </li>
            <li onClick={onLogout}>
                <LogoutIcon color="var(--brand)" />
                <span>{t('logOut')}</span>
            </li>
        </Dropdown>
    );
};

export default memo(WalletDropdown);
